<template>
  <div>
    <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
      <SpFilterFormItem prop="name">
        <el-input v-model="formData.name" placeholder="请输入配置名称" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="dealer_id">
        <el-button size="mini" style="height: 36px;" icon="el-icon-circle-plus-outline" @click="addDealerAction">{{  relDealers.length > 0 ? `已选中${relDealers.length}个经销商` : '选择关联经销商'  }}</el-button>
        <!-- <el-tag :key="item.dealer_id" class="new-tag" v-for="(item,index) in relDealers" closable :disable-transitions="false" @close="dealerhandleClose(index)"> {{item.name}}</el-tag> -->
      </SpFilterFormItem>
    </SpFilterForm>
    <SpFinder
      ref="finder"
      row-key="id"
      :split-count="10"
      :url="table_url"
      :setting="setting"
      fixed-row-action
      reserve-selection
      :hooks="{
        beforeSearch: beforeSearch
      }"
    >
      <template slot="tableTop">
        <el-button type="primary" size="medium" @click="addUnionPayConfig">添加</el-button>
        <ImportDialog
          ref="importDialog"
          buttonName="批量导入"
          buttonSize="medium"
          fileName="批量导入"
          fileType="upload_ums_payment_setting"
        />
        <el-button type="primary" size="medium" @click="deleteUnionPayConfig">批量删除</el-button>
      </template>
    </SpFinder>
  <DealerSelect :store-visible="dealerVisible" :is-valid="true" :rel-data-ids="relDealers" :get-status="dealerStatus" @chooseStore="chooseStore" @closeStoreDialog="closeStoreDialog" :isSingleSelect="false"></DealerSelect>
  </div>
</template>
<script>
import DealerSelect from '@/components/function/dealerSelect'
import ImportDialog from '@/components/importDialog'
import { useDialog } from '@shopex/finder'
import { tableSetting } from './config'
import { List, createSetting, deleteSetting } from './api'

export default {
  components: {
    DealerSelect,
    ImportDialog
  },
  data () {
    return {
      table_url: List,
      dealerVisible: false,
      dealerStatus: false,
      relDealers: [],
      formData: {
        name: '',
        dealer_id: ''
      }
    }
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  mounted() {
  },
  methods: {
    beforeSearch(params) {
      params = {
        ...params,
        ...this.formData,
        dealer_id: this.relDealers.map(item => item.dealer_id).join(','),
      }
      return params
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    onSearch () {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.formData.name = ''
      this.formData.dealer_id = ''
      this.relDealers = []
      this.refresh()
    },
    addUnionPayConfig () {
      useDialog(null, {
        title: `新增银联商务配置`,
        width: '50%',
        component: () => import('./comps/create.vue'),
        actions: [
          { label: '取消', key: 'close', size: 'default' },
          { label: '提交', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(async (arg) => {
        if(arg) {
          try {
            await createSetting(arg)
            this.$message.success('添加成功')
            this.refresh()
          } catch (e) {
            console.log(e, 'error')
          }
        }
      })
    },
    deleteUnionPayConfig () {
      const selection = this.$refs.finder.$refs.finderTable.getSelection()
      if (selection.length === 0) return this.$message.error('请选择需要删除的数据')
      this.$confirm('请确认是否批量删除？', '提示').then(async () => {
        const ids = selection.map(v => v.id)
        await deleteSetting(ids)
        this.$message.success('删除成功')
        this.refresh()
      })
    },
    addDealerAction() {
      this.dealerVisible = true
      this.dealerStatus = true
    },
    dealerhandleClose(index) {
      this.relDealers.splice(index, 1);
    },
    closeStoreDialog () {
      this.dealerVisible = false
    },
    chooseStore (data) {
      this.dealerVisible = false
      this.dealerStatus = false
      if (data === null || data.length <= 0) return
      this.relDealers = data
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .sp-finder .cell .sp-finder-actions__wrap {
  justify-content: center !important;
}
</style>
